<template>
  <div class="last-second" ref="lastSecond">
    <div class="last-seconds" v-for="(items,index) in datas" :key="'datalist_'+index">
      <ul>
        <li v-for="(item,index) in items" :key="index" @click="onSelect(item.name)">
          <span>{{item.name}}</span>
          <span>{{item.value}}<b>{{item.unit}}</b></span>
          <span>
            <b v-if="item.levelColor" :style="'color:'+item.levelColor+';'">{{item.levelName}}</b>
          </span>
          <transition name="fade_sj">
            <i class="li-icon" v-show="item.isExtend && (item.showBar || item.desc)"></i>
          </transition>
        </li>
      </ul>

      <div class="explain_box">
        <transition name="fade_data" v-for="(item,index) in items" :key="index">
          <div class="explain" v-show="item.isExtend && (item.showBar || item.desc)">
            <div class="explain-top" v-if="item.showBar">
              <div class="progrees-math">
                <div :class="boundaries_length2class[item.boundaries.length]" v-for="(val,index,key) in item.boundaries" :key="key">{{val}}
                </div>
              </div>

              <div class="top-progress-one" v-if="item.levelNames.length == 2">
                <div class="top-progress-line" v-if="item.level == 0" :style="'width:'+(item.value >item.max?100:item.value*((100/(item.levelNames.length)*1)/item.boundaries[item.level]))+'%;background:'+item.bar[item.level]+';'">
                </div>

                <div class="top-progress-line" v-if="item.level > 0" :style="'width:'+ (item.value >=item.max?100:((100/(item.levelNames.length*item.level))+((50/item.boundaries[item.level-1])*(item.value-item.boundaries[item.level-1])))) +'%;background:'+item.bar[item.level]+';'">
                </div>
                <span class="cicle" :style="'border-color:'+item.bar[item.level]+';'"></span>
              </div>

              <div v-else :class="top_progress2class[item.levelNames.length]">
                <div class="top-progress-line" :style="`width:${calPresent(item, 0)}%;background:${item.bar[item.level]};`"></div>
                <span class="cicle" :style="'border-color:'+item.bar[item.level]+';'"></span>
              </div>

              <div class="progrees-text">
                <div v-for="(val,index) in item.levelNames" :key="index">
                  {{val}}</div>
              </div>
            </div>

            <div class="explain-bottom" v-show="item.desc">
              {{item.desc}}
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['datas','noExtend'],
  data() {
    return {
      boundaries_length2class: {
        1: 'math-one',
        2: 'math-two',
        3: 'math-three',
        4: 'math-four',
      },
      top_progress2class: {
        2: 'top-progress-one',
        3: 'top-progress-two',
        4: 'top-progress-three',
        5: 'top-progress',
      },
    }
  },
  watch:{
    noExtend(nV) {
      if (nV) {
        this.onSelect(void 0)
      }
    }
  },
  methods: {
    onSelect(ids) {
      for (let i = 0; i < this.datas.length; i++) {
        for (let j = 0; j < this.datas[i].length; j++) {
          if (this.datas[i][j].name == ids) {
            this.$set(this.datas[i][j],'isExtend',!this.datas[i][j].isExtend)
          } else {
            this.$set(this.datas[i][j],'isExtend',false)
          }
        }
      }
    },
    calPresent(item){ // zero
      let val = 0
      // 超出范围
      if(item.value<=item.mix){
        return 0
      } else if(item.value >= item.max){
        return 100
      }

      let middle = (item.boundaries[item.boundaries.length-1] -item.boundaries[0])
      let width = middle / (item.boundaries.length - 1) * (item.boundaries.length + 1)
      let min = item.boundaries[0] - (width - middle)/2
      let max = width - (width - middle)/2
      let present = ((item.value - min)/width*100)

      // console.log('calPresent', item.value,item.mix, item.min, ((item.value - min)/width*100))
      if(present > 100) return 100
      else if(present < 0) return 0
      return present.toFixed(1)
      
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/px2rem';
@import '~@/assets/css/common.scss';
.last-second {
  width: 100%;
  background-color: #18bdef;
}
.last-second .last-seconds {
  width: 100%;
}
.last-second .last-seconds:last-child {
  border: 0;
}
.last-seconds ul {
  width: 100%;
  height: 100%;
  padding: 0.1rem 0.1rem;
  box-sizing: border-box;
  height: 1.1rem;
  border-bottom: 0.01rem solid rgba(255, 255, 255, 0.2);
}
.last-seconds ul li {
  width: 33%;
  float: left;
  border-right: 0.01rem solid rgba(255, 255, 255, 0.2);
  position: relative;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.last-seconds ul li:nth-child(3) {
  border: 0 !important;
}

.last-second .last-seconds:last-child ul li:last-child {
  border-right: 0.01rem solid rgba(255, 255, 255, 0.2);
}

.last-seconds .explain {
  width: 100%;
  padding: 0.12rem 0.2rem;
  box-sizing: border-box;
  background-color: #fff;
}

.li-icon {
  width: 0.15rem;
  height: 0.1rem;
  display: block;
  position: relative;
  bottom: -0.095rem;
  left: 50%;
  background: url('../../assets/images/triangle_icon.png') no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  margin-left: -0.075rem;
}

.explain .explain-top {
  margin-bottom: 0.16rem;
}
.explain .explain-bottom {
  font-size: 0.13rem;
  color: #808080;
}

@mixin progress($url) {
  width: 100%;
  height: 0.04rem;
  background: url($url) no-repeat;
  background-size: 100% 100%;
  position: relative;
  margin: 0.06rem 0;
}

.explain-top .top-progress {
  @include progress('../../assets/images/four-scale.png');
}
.explain-top .top-progress-three {
  @include progress('../../assets/images/three-scale.png');
}
.explain-top .top-progress-two {
  @include progress('../../assets/images/two-scale.png');
}
.explain-top .top-progress-one {
  @include progress('../../assets/images/one-scale.png');
}

.explain-top .progrees-text {
  @extend .flex;
  width: 100%;
  height: 0.14rem;
  div {
    @extend .flex-1;
    font-size: 0.12rem;
    color: #999;
    text-align: center;
  }
}
.explain-top .progrees-math {
  width: 100%;
  height: 0.12rem;
  margin-bottom: 0.04rem;
  div {
    font-size: 0.12rem;
    color: #4d4d4d;
    float: left;
    text-align: right;
  }
}

.progrees-math .math-four:nth-child(1) {
  width: 22%;
}
.progrees-math .math-four:nth-child(2) {
  width: 20%;
}
.progrees-math .math-four:nth-child(3) {
  width: 20%;
}
.progrees-math .math-four:nth-child(4) {
  width: 20%;
}
.progrees-math .math-three:nth-child(1) {
  width: 27%;
}
.progrees-math .math-three:nth-child(2) {
  width: 25%;
}
.progrees-math .math-three:nth-child(3) {
  width: 25%;
}
.progrees-math .math-two:nth-child(1) {
  width: 35%;
}
.progrees-math .math-two:nth-child(2) {
  width: 34%;
}
.progrees-math .math-one:nth-child(1) {
  width: 52%;
}

.top-progress-line {
  /* width: 0.4rem; */
  background-color: green;
  height: 100%;
  float: left;
}

.cicle {
  width: 0.08rem;
  height: 0.08rem;
  border-radius: 0.08rem;
  background-color: #fff;
  display: inline-block;
  position: absolute;
  top: -0.04rem;
  margin-left: -0.01rem;
  border-radius: 50%;
  border: 0.02rem solid greenyellow;
}

ul li span {
  display: block;
  text-align: center;
}
ul li span:first-child {
  margin-top: 0.12rem;
  font-size: 0.15rem;
  color: #fff;
  opacity: 0.8;
  height: 0.2rem;
  line-height: 0.2rem;
}
ul li span:nth-child(2) {
  margin-top: 0.1rem;
  font-size: 0.18rem;
  height: 0.18rem;
  line-height: 0.18rem;
  color: #fff;
  font-family: 'Arial';
}
ul li span:nth-child(2) b {
  font-size: 0.1rem;
}
ul li span:nth-child(3) {
  margin-top: 0.08rem;
  font-size: 0.12rem;
  height: 0.16rem;
  line-height: 0.16rem;
}
ul li span:nth-child(3) b {
  display: inline-block;
  padding: 0 0.1rem;
  background-color: #fff;
  border-radius: 0.16rem;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s;
}
.slide-enter,
.slide-leave-top {
  transform: translate3d(0, -100%, 0);
}
.fade_data-enter-active {
  transition: all 0.6s ease-out;
}
.fade_data-leave-active {
  display: none;
}
.fade_data-enter, .fade_data-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
}
.fade_sj-enter-active {
  transition: all 0.5s 0.2s ease-out;
}
.fade_sj-leave-active {
  display: none;
}
.fade_sj-enter, .fade_sj-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/template/healthReport.vue